/**
 * useCommunityImage — compile-time-typed registry of png assets under
 * `lib/components/Community/**` (and `lib/services/community/**` when those
 * land). The `loaders` map gives webpack the static `import()` call sites it
 * needs to bundle each asset, and `keyof typeof loaders` exposes a literal
 * union so callers fail at compile time when the filename is unknown.
 *
 * Parallel to `lib/components/OracleCommons/useOracleImage.ts`; both descend
 * from the `IMAGE_PATHS` pattern in
 * `lib/components/AccountCancelV2/AccountCancelDissatisfied/AccountCancelDissatisfied.jsx`.
 *
 * To register a new png, drop it under the consuming component's `img/`
 * directory and add one line below.
 */
import { useState, useEffect } from 'react'

const loaders = {
  'watercolor.png': () => import('../../../components/Community/Identity/Settings/CommunityProfileWelcome/img/watercolor.png'),
  'community-my-library-welcome-hero.png': () => import('../../../components/Community/Identity/Library/CommunityMyLibraryWelcome/img/community-my-library-welcome-hero.png'),
  'library-welcome-device-tablet.png': () => import('../../../components/Community/Identity/Library/CommunityMyLibraryWelcome/img/library-welcome-device-tablet.png'),
  'library-welcome-device-phone.png': () => import('../../../components/Community/Identity/Library/CommunityMyLibraryWelcome/img/library-welcome-device-phone.png'),
}

export type CommunityImageFilename = keyof typeof loaders

export default function useCommunityImage (filename: CommunityImageFilename): string | null {
  const [src, setSrc] = useState<string | null>(null)
  useEffect(() => {
    let cancelled = false
    loaders[filename]().then((mod) => {
      if (!cancelled) setSrc(mod.default)
    })
    return () => { cancelled = true }
  }, [filename])
  return src
}
